<!--
  One block, opened from its line on the business's page (DOC-89-A §3; FLOW-401).
  Entries From you / From CapX with a date, in the server's words; Add to this
  inside the pop-up; Close. No count, no state word.
-->
@if (data.block(); as block) {
  <div class="cbcd__head">
    <h2 mat-dialog-title class="cbcd__title">{{ block.name }}</h2>
    <button
      mat-icon-button
      type="button"
      class="cbcd__close"
      aria-label="Close"
      matTooltip="Close"
      (click)="close()"
    >
      <app-icon name="x" [size]="18" />
    </button>
  </div>

  <mat-dialog-content data-testid="client-block-dialog">
    @if (block.no_longer_needed) {
      <p class="cbcd__muted">No longer needed</p>
    }
    @if (block.entries.length === 0) {
      <p class="cbcd__muted">Nothing here yet.</p>
    }
    @for (entry of block.entries; track entry.short_id) {
      <div class="cbcd-entry" [attr.data-testid]="'client-entry-' + entry.short_id">
        @if (entry.text) {
          <p class="cbcd-entry__text">{{ entry.text }}</p>
        }
        @if (entry.file_name) {
          <p class="cbcd-entry__file">
            <app-icon name="document" [size]="14" />
            <button type="button" class="cbcd__link" (click)="data.openFile(entry)">
              {{ entry.file_name }}
            </button>
          </p>
        }
        <p class="cbcd-entry__from">{{ entry.from_label }} · {{ entry.on | date: 'd MMM yyyy' }}</p>
      </div>
    }

    @if (!block.no_longer_needed && adding()) {
      <form
        class="cbcd-form"
        data-testid="client-add-form"
        (submit)="$event.preventDefault(); save()"
      >
        <label class="cbcd__label" for="cbcd-text">Add a note</label>
        <textarea
          id="cbcd-text"
          class="cbcd__input"
          data-testid="client-add-text"
          rows="3"
          [value]="text()"
          (input)="text.set($any($event.target).value)"
        ></textarea>
        <label class="cbcd__label" for="cbcd-file">Add a document (any kind)</label>
        <input #fileInput id="cbcd-file" type="file" (change)="onFile($event)" />
        <div class="cbcd-form__actions">
          <button mat-button type="button" data-testid="client-add-cancel" (click)="cancelAdd()">
            Cancel
          </button>
          <button
            mat-flat-button
            type="submit"
            data-testid="client-add-save"
            [disabled]="!canSave()"
          >
            Add
          </button>
        </div>
      </form>
    }

    @if (error(); as message) {
      <p class="cbcd__error" role="alert">{{ message }}</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="cbcd__actions">
    @if (!block.no_longer_needed && !adding()) {
      <button
        mat-stroked-button
        type="button"
        data-testid="client-add-to-this"
        [disabled]="busy()"
        (click)="openAdd()"
      >
        <app-icon name="plus" [size]="16" /> Add to this
      </button>
    } @else {
      <span></span>
    }
    <button mat-flat-button type="button" data-testid="client-block-close" (click)="close()">
      Close
    </button>
  </mat-dialog-actions>
}
